<template>
  <div
    class="tab-pane fade show active"
    id="Wallet"
    role="tabpanel"
    aria-labelledby="Wallet-tab"
  >
  <mainHeader title="WALLET"></mainHeader>
    <div class="wallet" style="padding: 0 12px;">
      <div class="row">
        <div class="tab-content">
          <div class="tab-pane fade show active" id="coinBTC" role="tabpanel">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Balances</h5>
                <ul>
                  <li class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <h2>Blance : {{ userInfo.money || 0.00 }}</h2>
                    </div>
                    <div>
                      <h3>0</h3>
                    </div>
                  </li>
                </ul>
                <button class="btn green" @click="handleDeposit">
                  Deposit
                </button>
                <button class="btn red" @click="handleWithdraw">
                  Withdraw
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mainHeader from "../../../components/mainHeader.vue";
export default {
  components: {mainHeader},
  data() {
    return {
      balance: 0.00, // 新增余额字段
    };
  },
  computed: {
    userInfo() {
      if (!this.$store.state.isLogin) {
        return { money: 0.00 };
      }
      return this.$store.state.userInfo;
    },
  },
  created() {
    this.loading = true;
    if (this.$store.state.isLogin) {
      this.$store.dispatch("getUserInfo").finally(() => {
        this.loading = false;
      });
    }
    this.loading = false;
  },
  methods: {
    handleDeposit() {
      this.loading = true;
      this.$router.push("/user/deposit").finally(() => {
        this.loading = false;
      });
    },
    handleWithdraw() {
      this.loading = true;
      this.$router.push("/user/withdraw").finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8); /* 半透明白色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* 如果是深色主题，可以调整遮罩背景色 */
[data-bs-theme="dark"] .loading-overlay {
  background: rgba(0, 0, 0, 0.8);
}

.card {
  position: relative; /* 确保遮罩定位正确 */
}
</style>
